import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-xl font-bold whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <span className="font-heading text-2xl">在线撸</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {[
              { to: '/category/video', label: '撸视频' },
              { to: '/category/cat', label: '撸猫' },
              { to: '/category/bbq', label: '撸串' },
              { to: '/category/fitness', label: '撸铁' },
              { to: '/category/code', label: '撸代码' },
              { to: '/category/exam', label: '撸题' },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:opacity-80 ${
                  scrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white/90 hover:text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:opacity-80 ${
                scrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white/90 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-3 space-y-1">
            {[
              { to: '/category/video', label: '在线撸视频' },
              { to: '/category/cat', label: '在线撸猫' },
              { to: '/category/bbq', label: '在线撸串' },
              { to: '/category/fitness', label: '在线撸铁' },
              { to: '/category/code', label: '在线撸代码' },
              { to: '/category/exam', label: '在线撸题' },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="block py-2.5 text-sm text-gray-700 hover:text-orange-600 transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="block py-2.5 text-sm text-gray-700 hover:text-orange-600 transition-colors border-t pt-3 mt-2"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}